var pe = Object.defineProperty;
var Q = Object.getOwnPropertySymbols;
var fe = Object.prototype.hasOwnProperty, ce = Object.prototype.propertyIsEnumerable;
var X = (v, f, m) => f in v ? pe(v, f, { enumerable: !0, configurable: !0, writable: !0, value: m }) : v[f] = m, Y = (v, f) => {
  for (var m in f || (f = {}))
    fe.call(f, m) && X(v, m, f[m]);
  if (Q)
    for (var m of Q(f))
      ce.call(f, m) && X(v, m, f[m]);
  return v;
};
var j = (v, f, m) => new Promise((_, a) => {
  var P = (g) => {
    try {
      t(m.next(g));
    } catch (p) {
      a(p);
    }
  }, i = (g) => {
    try {
      t(m.throw(g));
    } catch (p) {
      a(p);
    }
  }, t = (g) => g.done ? _(g.value) : Promise.resolve(g.value).then(P, i);
  t((m = m.apply(v, f)).next());
});
import "../../../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import he from "../formMixin.js";
import { postRuleValidate as ve } from "../../../../request/commoditycenter/form/ruleValidate/post.js";
import { getGetAllMaterial as be } from "../../../../request/bsplatform/commodity/getAllMaterial/get.js";
import { postCodes as ge } from "../../../../request/commoditycenter/commodity/classification/dictionary/rela/codes/post.js";
import { useLanguage as ye } from "../../../../utils/useLanguage.js";
import { defineComponent as we, useTemplateRef as Ne, watch as Z, onMounted as Me, resolveComponent as We, openBlock as I, createElementBlock as Ce, createElementVNode as N, createVNode as o, withCtx as s, createTextVNode as C, createBlock as z, createCommentVNode as L, Fragment as Se } from "../../../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import xe from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/legacy-grid/src/Row.js";
import c from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/legacy-grid/src/Col.js";
import { useMessage as _e } from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import { ref as x, unref as e } from "../../../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import Pe from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import ke from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import Ae from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/Form.js";
import h from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/FormItem.js";
import U from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/input-number/src/InputNumber.js";
import H from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/select/src/Select.js";
import Fe from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/input/src/Input.js";
import $ from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/radio/src/RadioGroup.js";
import T from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/radio/src/Radio.js";
import { toDisplayString as M } from "../../../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
import ee from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import Ie from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
const Ue = { style: { color: "#909399" } }, He = { style: { display: "flex", "justify-content": "center", gap: "8px" } }, dt = /* @__PURE__ */ we({
  __name: "chaungman",
  props: {
    options: {},
    locale: {}
  },
  emits: ["hide-dialog", "onSuccess"],
  setup(v, { expose: f, emit: m }) {
    const { i18n: _ } = ye(), { t: a } = _.global, P = Ne("chuangman"), {
      formSelect: i,
      // 混入中的响应式数据（与组件共享）
      formData: t,
      // 混入中的表单数据（替代组件自身定义）
      rules: g,
      // 混入中的校验规则（替代组件自身定义）
      allowEditFun: p,
      // 混入中的方法
      setDefault: te,
      // 混入中的方法
      setRequired: ae
      // 混入中的方法
    } = he(), V = _e(), w = v;
    Z(
      () => w.locale,
      (u) => {
        _.global.locale.value = u || "zh-CN";
      },
      { immediate: !0 }
    );
    const B = m, b = x(!1), E = x(!0);
    x([]);
    const le = x(null), k = x(null), oe = (u) => {
      t.attachments.push(u);
    }, R = () => {
      B("hide-dialog");
    }, D = (u) => {
      if (u === a("是")) {
        const l = { classificationId: 1 };
        b.value = !0, be(l).then((n) => {
          if (b.value = !1, n.status) {
            let d = [];
            Array.isArray(n.data) && n.data.forEach((y) => {
              var A;
              if (Array.isArray(y.attributes) && y.attributes.length > 0) {
                const S = y.attributes.find((W) => W.attributeCode === "model");
                if (S && ((A = S.attributeValues) != null && A[0])) {
                  const W = S.attributeValues[0].split(",").map((F) => ({
                    value: F,
                    valueCode: F,
                    default: !1
                  }));
                  W && (d = d.concat(W));
                }
              }
            });
            const r = i.value.find((y) => y.code === "productModel");
            r && (r.values = d);
          }
        }).catch(() => {
          b.value = !1;
        });
      } else {
        const l = i.value.find((n) => n.code === "productModel");
        l && w.options.model && (l.values = w.options.model.split(",").map((n) => ({
          value: n,
          valueCode: n,
          default: !1
        })));
      }
    }, q = () => j(this, null, function* () {
      if (k.value)
        try {
          yield k.value.validate(), t.isStandard = t.isSpecial;
          const {
            productModel: u,
            leftProductWidth: l,
            productHeight: n,
            rightProductWidth: d,
            frontProductWidth: r,
            closeType: y,
            isSpecial: A,
            mainAmaterial: S,
            bMaterial: W,
            attachments: F,
            isStandard: re,
            roomName: ie,
            urgent: ue,
            deliveryMethod: ne
          } = t, J = Number(t.leftProductWidth || 0) + Number(t.frontProductWidth || 0) + Number(t.rightProductWidth || 0);
          t.productWidth = J;
          const O = {
            productModel: u,
            leftProductWidth: l,
            productHeight: n,
            rightProductWidth: d,
            frontProductWidth: r,
            closeType: y,
            isSpecial: A,
            mainAmaterial: S,
            bMaterial: W,
            attachments: F,
            isStandard: re,
            roomName: ie,
            urgent: ue,
            deliveryMethod: ne,
            productWidth: J,
            remark: ""
            // 添加 remark 属性
          };
          if (t.isSpecial === a("是") && (!t.attachments || t.attachments.length === 0)) {
            V.error(a("请上传附件"));
            return;
          }
          t.attachments && t.attachments.length > 0 && (t.remark = O.remark = "加工见附件");
          const me = Number(l || 0) + Number(r || 0) + Number(d || 0);
          t.productWidth = O.productWidth = me, b.value = !0;
          const K = yield ve([
            {
              data: JSON.stringify(O),
              classificationCode: "FL_chaungman"
            }
          ]);
          b.value = !1, K.status ? (V.success(a("操作成功")), B("onSuccess", Y({}, t)), B("hide-dialog")) : V.error(K.message || "操作失败，请检查输入项");
        } catch (u) {
          b.value = !1, console.error("表单提交失败:", u);
        }
    }), de = () => {
      Object.assign(t, {
        productModel: "",
        productWidth: "",
        frontProductWidth: "",
        productHeight: "",
        closeType: "",
        isSpecial: "否",
        mainAmaterial: "",
        bMaterial: "",
        isStandard: "否",
        attachments: [],
        roomName: "",
        urgent: "否",
        deliveryMethod: "",
        leftProductWidth: "",
        rightProductWidth: ""
      });
    }, G = () => j(this, null, function* () {
      const { commodityId: u } = w.options;
      if (u === void 0) {
        console.warn("commodityId 未定义，跳过请求");
        return;
      }
      const l = {
        commodityId: String(w.options.commodityId),
        classificationCode: "FL_chaungman",
        codes: []
      };
      i.value = [], b.value = !0;
      try {
        const n = yield ge(l);
        if (b.value = !1, n) {
          i.value = n;
          const d = w.options.model ? w.options.model.split(",").map((y) => ({
            value: y,
            valueCode: y,
            default: !1
          })) : [];
          i.value.push({ code: "productModel", values: d });
          const r = [
            { type: "string", name: "closeType", message: a("请选择开合方式") },
            { type: "string", name: "deliveryMethod", message: a("请选择配送方式") },
            { type: "number", name: "leftProductWidth", message: a("请输入左转包尺寸-宽") },
            { type: "number", name: "rightProductWidth", message: a("请输入右转包尺寸-宽") },
            { type: "number", name: "frontProductWidth", message: a("请输入正面尺寸-宽") },
            { type: "number", name: "productHeight", message: a("请输入成品尺寸-高") },
            { type: "string", name: "roomName", message: a("请输入房间名") },
            { type: "string", name: "urgent", message: a("请选择是否加急") },
            { type: "string", name: "isSpecial", message: a("请选择是否特殊定制") },
            { type: "string", name: "mainAmaterial", message: a("请选择主布A面料") },
            { type: "string", name: "bMaterial", message: a("请选择配布B面料") },
            { type: "array", name: "attachments", message: a("请上传附件") }
          ];
          ae(r, n), te(r, n);
        }
      } catch (n) {
        b.value = !1, console.error("获取分类数据失败:", n);
      }
    });
    function se(u, l) {
      t[u] = l;
    }
    return Z(
      () => w.options,
      (u) => {
        if (de(), Object.keys(t).forEach((l) => {
          Object.keys(t).forEach((n) => {
            const d = n, r = u[d];
            r !== void 0 && se(d, r);
          });
        }), t.productModel = u.model || "", u.productHeight) {
          const l = Number(u.productHeight);
          t.productHeight = isNaN(l) ? 0 : l / 5;
        }
        G();
      },
      { immediate: !0, deep: !0 }
    ), Me(() => {
      G();
      const u = sessionStorage.getItem("userInfo");
      le.value = u ? JSON.parse(u) : null;
    }), f({
      shalianForm: k,
      loading: b,
      isShowDialog: E,
      formSelect: i,
      formData: t,
      rules: g,
      uploadFunc: oe,
      clearForm: R,
      selectIsSpecial: D,
      submitFrom: q
    }), (u, l) => {
      const n = We("op-file-upload");
      return I(), Ce(Se, null, [
        N("div", {
          ref_key: "chuangman",
          ref: P
        }, null, 512),
        o(e(Ie), {
          bordered: "",
          show: E.value,
          "onUpdate:show": l[12] || (l[12] = (d) => E.value = d),
          "mask-closable": !1,
          to: P.value || "body"
        }, {
          default: s(() => [
            o(e(Pe), {
              class: "tw:!w-[50%] tw:!box-border tw:!text-left",
              title: e(a)("窗幔"),
              bordered: !1,
              role: "dialog",
              closable: "",
              "header-class": "tw:!text-center",
              onClose: R
            }, {
              default: s(() => [
                o(e(ke), { show: b.value }, {
                  default: s(() => [
                    o(e(Ae), {
                      model: e(t),
                      rules: e(g),
                      ref_key: "shalianForm",
                      ref: k,
                      "label-placement": "left",
                      "label-width": "120px",
                      class: "tw:!text-left",
                      "require-mark-placement": "right-hanging",
                      size: "small"
                    }, {
                      default: s(() => [
                        o(e(xe), null, {
                          default: s(() => [
                            o(e(c), { span: 24 }, {
                              default: s(() => [
                                o(e(h), {
                                  label: e(a)("左转包尺寸-宽"),
                                  path: "leftProductWidth"
                                }, {
                                  default: s(() => [
                                    o(e(U), {
                                      "show-button": !1,
                                      disabled: !e(p)(e(i), "leftProductWidth"),
                                      value: e(t).leftProductWidth,
                                      "onUpdate:value": l[0] || (l[0] = (d) => e(t).leftProductWidth = d),
                                      min: 0,
                                      class: "tw:!w-[100%] tw:!text-center",
                                      placeholder: e(a)("请输入左转包尺寸-宽")
                                    }, {
                                      suffix: s(() => l[13] || (l[13] = [
                                        N("span", null, "mm", -1)
                                      ])),
                                      _: 1
                                    }, 8, ["disabled", "value", "placeholder"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            }),
                            o(e(c), { span: 24 }, {
                              default: s(() => [
                                o(e(h), {
                                  label: e(a)("右转包尺寸-宽"),
                                  path: "rightProductWidth"
                                }, {
                                  default: s(() => [
                                    o(e(U), {
                                      "show-button": !1,
                                      disabled: !e(p)(e(i), "rightProductWidth"),
                                      value: e(t).rightProductWidth,
                                      "onUpdate:value": l[1] || (l[1] = (d) => e(t).rightProductWidth = d),
                                      min: 0,
                                      class: "tw:!w-[100%] tw:!text-center",
                                      placeholder: e(a)("请输入右转包尺寸-宽")
                                    }, {
                                      suffix: s(() => l[14] || (l[14] = [
                                        N("span", null, "mm", -1)
                                      ])),
                                      _: 1
                                    }, 8, ["disabled", "value", "placeholder"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            }),
                            o(e(c), { span: 24 }, {
                              default: s(() => [
                                o(e(h), {
                                  label: e(a)("成品尺寸-高"),
                                  path: "productHeight"
                                }, {
                                  default: s(() => [
                                    o(e(U), {
                                      "show-button": !1,
                                      disabled: !e(p)(e(i), "productHeight"),
                                      value: e(t).productHeight,
                                      "onUpdate:value": l[2] || (l[2] = (d) => e(t).productHeight = d),
                                      min: 0,
                                      class: "tw:!w-[100%] tw:!text-center",
                                      placeholder: e(a)("请输入成品尺寸-高")
                                    }, {
                                      suffix: s(() => l[15] || (l[15] = [
                                        N("span", null, "mm", -1)
                                      ])),
                                      _: 1
                                    }, 8, ["disabled", "value", "placeholder"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            }),
                            o(e(c), { span: 24 }, {
                              default: s(() => [
                                o(e(h), {
                                  label: e(a)("正面尺寸-宽"),
                                  path: "frontProductWidth"
                                }, {
                                  default: s(() => [
                                    o(e(U), {
                                      "show-button": !1,
                                      disabled: !e(p)(e(i), "frontProductWidth"),
                                      value: e(t).frontProductWidth,
                                      "onUpdate:value": l[3] || (l[3] = (d) => e(t).frontProductWidth = d),
                                      min: 0,
                                      class: "tw:!w-[100%] tw:!text-center",
                                      placeholder: e(a)("请输入正面尺寸-宽")
                                    }, {
                                      suffix: s(() => l[16] || (l[16] = [
                                        N("span", null, "mm", -1)
                                      ])),
                                      _: 1
                                    }, 8, ["disabled", "value", "placeholder"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            }),
                            o(e(c), { span: 24 }, {
                              default: s(() => [
                                o(e(h), {
                                  label: e(a)("贴合方式"),
                                  path: "closeType"
                                }, {
                                  default: s(() => {
                                    var d;
                                    return [
                                      o(e(H), {
                                        value: e(t).closeType,
                                        "onUpdate:value": l[4] || (l[4] = (r) => e(t).closeType = r),
                                        placeholder: e(a)("请选择开合方式"),
                                        disabled: !e(p)(e(i), "closeType"),
                                        options: ((d = e(i).find((r) => r.code === "closeType")) == null ? void 0 : d.values) || [],
                                        "label-field": "value",
                                        "value-field": "valueCode",
                                        "key-field": "valueCode",
                                        class: "tw:!w-[50%] tw:!text-left",
                                        to: !1
                                      }, null, 8, ["value", "placeholder", "disabled", "options"])
                                    ];
                                  }),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            }),
                            o(e(c), { span: 24 }, {
                              default: s(() => [
                                o(e(h), {
                                  label: e(a)("房间名"),
                                  path: "roomName"
                                }, {
                                  default: s(() => [
                                    o(e(Fe), {
                                      disabled: !e(p)(e(i), "roomName"),
                                      value: e(t).roomName,
                                      "onUpdate:value": l[5] || (l[5] = (d) => e(t).roomName = d),
                                      placeholder: ""
                                    }, null, 8, ["disabled", "value"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            }),
                            o(e(c), { span: 24 }, {
                              default: s(() => [
                                o(e(h), {
                                  label: e(a)("配送方式"),
                                  path: "deliveryMethod"
                                }, {
                                  default: s(() => {
                                    var d;
                                    return [
                                      o(e(H), {
                                        value: e(t).deliveryMethod,
                                        "onUpdate:value": l[6] || (l[6] = (r) => e(t).deliveryMethod = r),
                                        placeholder: e(a)("请选择配送方式"),
                                        disabled: !e(p)(e(i), "deliveryMethod"),
                                        options: ((d = e(i).find((r) => r.code === "deliveryMethod")) == null ? void 0 : d.values) || [],
                                        "label-field": "value",
                                        "value-field": "valueCode",
                                        "key-field": "valueCode",
                                        class: "tw:!w-[50%] tw:!text-left",
                                        to: !1
                                      }, null, 8, ["value", "placeholder", "disabled", "options"])
                                    ];
                                  }),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            }),
                            o(e(c), { span: 24 }, {
                              default: s(() => [
                                o(e(h), {
                                  label: e(a)("是否加急"),
                                  path: "urgent"
                                }, {
                                  default: s(() => [
                                    o(e($), {
                                      disabled: !e(p)(e(i), "urgent"),
                                      value: e(t).urgent,
                                      "onUpdate:value": l[7] || (l[7] = (d) => e(t).urgent = d)
                                    }, {
                                      default: s(() => [
                                        o(e(T), { value: "是" }, {
                                          default: s(() => [
                                            C(M(e(a)("是")), 1)
                                          ]),
                                          _: 1
                                        }),
                                        o(e(T), { value: "否" }, {
                                          default: s(() => [
                                            C(M(e(a)("否")), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["disabled", "value"]),
                                    N("span", Ue, " (" + M(e(a)("注：加急需收取加急费35元")) + ")", 1)
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            }),
                            o(e(c), { span: 24 }, {
                              default: s(() => [
                                o(e(h), {
                                  label: e(a)("是否特殊定制"),
                                  path: "isSpecial"
                                }, {
                                  default: s(() => [
                                    o(e($), {
                                      disabled: !e(p)(e(i), "isSpecial"),
                                      value: e(t).isSpecial,
                                      "onUpdate:value": [
                                        l[8] || (l[8] = (d) => e(t).isSpecial = d),
                                        D
                                      ]
                                    }, {
                                      default: s(() => [
                                        o(e(T), { value: "是" }, {
                                          default: s(() => [
                                            C(M(e(a)("是")), 1)
                                          ]),
                                          _: 1
                                        }),
                                        o(e(T), { value: "否" }, {
                                          default: s(() => [
                                            C(M(e(a)("否")), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["disabled", "value"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            }),
                            e(t).isSpecial === e(a)("是") ? (I(), z(e(c), {
                              key: 0,
                              span: 24
                            }, {
                              default: s(() => [
                                o(e(h), {
                                  label: e(a)("主布A面料"),
                                  path: "mainAmaterial"
                                }, {
                                  default: s(() => {
                                    var d;
                                    return [
                                      o(e(H), {
                                        value: e(t).mainAmaterial,
                                        "onUpdate:value": l[9] || (l[9] = (r) => e(t).mainAmaterial = r),
                                        placeholder: e(a)("请选择主布A面料"),
                                        disabled: !e(p)(e(i), "mainAmaterial"),
                                        options: ((d = e(i).find((r) => r.code === "productModel")) == null ? void 0 : d.values) || [],
                                        "label-field": "value",
                                        "value-field": "valueCode",
                                        "key-field": "valueCode",
                                        class: "tw:!w-[50%] tw:!text-left",
                                        to: !1
                                      }, null, 8, ["value", "placeholder", "disabled", "options"])
                                    ];
                                  }),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            })) : L("", !0),
                            e(t).isSpecial === e(a)("是") ? (I(), z(e(c), {
                              key: 1,
                              span: 24
                            }, {
                              default: s(() => [
                                o(e(h), {
                                  label: e(a)("配布B面料"),
                                  path: "bMaterial"
                                }, {
                                  default: s(() => {
                                    var d;
                                    return [
                                      o(e(H), {
                                        value: e(t).bMaterial,
                                        "onUpdate:value": l[10] || (l[10] = (r) => e(t).bMaterial = r),
                                        placeholder: e(a)("请选择配布B面料"),
                                        disabled: !e(p)(e(i), "bMaterial"),
                                        options: ((d = e(i).find((r) => r.code === "productModel")) == null ? void 0 : d.values) || [],
                                        "label-field": "value",
                                        "value-field": "valueCode",
                                        "key-field": "valueCode",
                                        class: "tw:!w-[50%] tw:!text-left",
                                        to: !1
                                      }, null, 8, ["value", "placeholder", "disabled", "options"])
                                    ];
                                  }),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            })) : L("", !0),
                            e(t).isSpecial === e(a)("是") ? (I(), z(e(c), {
                              key: 2,
                              span: 24
                            }, {
                              default: s(() => [
                                o(e(h), {
                                  label: e(a)("附件"),
                                  path: "attachments"
                                }, {
                                  default: s(() => [
                                    o(n, {
                                      "business-type": "handbill",
                                      maxLength: 10,
                                      disabled: !e(p)(e(i), "attachments"),
                                      isDelete: !0,
                                      value: e(t).attachments,
                                      "onUpdate:value": l[11] || (l[11] = (d) => e(t).attachments = d)
                                    }, null, 8, ["disabled", "value"])
                                  ]),
                                  _: 1
                                }, 8, ["label"])
                              ]),
                              _: 1
                            })) : L("", !0)
                          ]),
                          _: 1
                        }),
                        N("div", He, [
                          o(e(ee), {
                            onClick: R,
                            size: "small"
                          }, {
                            default: s(() => [
                              C(M(e(a)("取消")), 1)
                            ]),
                            _: 1
                          }),
                          o(e(ee), {
                            type: "primary",
                            onClick: q,
                            size: "small"
                          }, {
                            default: s(() => [
                              C(M(e(a)("确定")), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["model", "rules"])
                  ]),
                  _: 1
                }, 8, ["show"])
              ]),
              _: 1
            }, 8, ["title"])
          ]),
          _: 1
        }, 8, ["show", "to"])
      ], 64);
    };
  }
});
export {
  dt as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/chaungman/chaungman.vue.js
// module id = 1253
// module chunks = 67